import {z} from 'zod';

export default z.object({
    autoplay: z.boolean().optional(),
    caption: z.string().optional(),
    video: z.object({
        id: z.string(),
        url: z.string(),
        // media-level credit, refreshed on save; not rendered publicly yet
        source: z.string().nullable().optional(),
        source_url: z.string().nullable().optional(),
    })
})
